import {
  NotificationTabType,
  MarkApi,
  StatusApiParams,
  DeleteApi,
  OperateTypeEnum,
} from "../constants";
import { message } from "antd";
import request from "project-config/services/request/request";
import { useTranslation } from "react-i18next";
import { useNotificationStore } from "../store/notification-store";
import { IBillingMessageInfoItem } from "./useInitNotification";

interface markMessageProps {
  markParams: StatusApiParams;
  messageComponent: NotificationTabType;
}
interface deleteMessageProps {
  delParams: StatusApiParams;
  messageComponent: NotificationTabType;
}
interface operateNotificationProps {
  selectAll: boolean;
  id: number[];
  type: OperateTypeEnum;
}

const basename = process.env.NODE_ENV === "development" ? "/" : "/center/user";
export function useBillingMessageOperate() {
  const { t } = useTranslation("center");
  const { currentNotificationTab } = useNotificationStore();
  const MessageTitleClick = {
    [NotificationTabType.BillingMessage]: async (
      message: IBillingMessageInfoItem
    ) => {
      if (!message.isRead) {
        await markMessage({
          markParams: { ids: [message.id], selectAll: false },
          messageComponent: NotificationTabType.BillingMessage,
        });
      }
      const link = `${window.location.protocol}//${window.location.host}${basename}/consumption?type=bill&billStartTime=${message.billMonth}`;
      const windowReference = window.open(link);
      if (windowReference === null) {
        window.location.href = link;
      }
    },
    [NotificationTabType.AppealBillingMessage]: async (message: any) => {
      if (!message.isRead) {
        await markMessage({
          markParams: { ids: [message.id], selectAll: false },
          messageComponent: NotificationTabType.AppealBillingMessage,
        });
      }
      const link = `${window.location.protocol}//${window.location.host}${basename}/consumption?type=bill&billStartTime=${message.billMonth}`;
      const windowReference = window.open(link);
      if (windowReference === null) {
        window.location.href = link;
      }
    },
  };

  const markMessage = async (data: markMessageProps) => {
    const { markParams, messageComponent } = data;

    const config =
      messageComponent === NotificationTabType.BillingMessage
        ? MarkApi[NotificationTabType.BillingMessage]
        : MarkApi[NotificationTabType.AppealBillingMessage];
    if (!config) return;
    await request.post(config.markApi, config.markParams(markParams));
  };

  const handleOpenNotification = async (row: IBillingMessageInfoItem) => {
    const clickFunc =
      currentNotificationTab === NotificationTabType.BillingMessage
        ? MessageTitleClick[NotificationTabType.BillingMessage]
        : MessageTitleClick[NotificationTabType.AppealBillingMessage];
    if (!clickFunc) return;
    await clickFunc(row);
  };

  const deleteMessage = async (data: deleteMessageProps) => {
    const { delParams, messageComponent } = data;
    const config =
      messageComponent === NotificationTabType.BillingMessage
        ? DeleteApi[NotificationTabType.BillingMessage]
        : DeleteApi[NotificationTabType.AppealBillingMessage];
    if (!config) return;
    await request.post(config.deleteApi, config.deleteParams(delParams));
  };
  const handleDeleteNotification = async (
    selectAll: boolean,
    id?: number[]
  ) => {
    const delParams = { ids: id || [], selectAll };
    await deleteMessage({
      delParams,
      messageComponent: currentNotificationTab,
    });
    message.success(t("message_success"));
  };
  const handleOperateNotification = async (
    params: operateNotificationProps
  ) => {
    const { selectAll, id, type } = params;
    if (type === OperateTypeEnum.read) {
      await markMessage({
        markParams: { ids: id, selectAll },
        messageComponent: currentNotificationTab,
      });
      return;
    }
    handleDeleteNotification(selectAll, id);
  };
  return {
    MessageTitleClick,
    deleteMessage,
    handleDeleteNotification,
    markMessage,
    handleOperateNotification,
    handleOpenNotification,
  };
}
